import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IdVerificationEligibilityDocument } from '../graphql/identity-verification/id-verification-eligibility-query.graphql';
import { EligibilityStatus } from '../types/identity-verification.types';
import { ApiInterfaceService } from './api-interface.service';

@Injectable({
  providedIn: 'root',
})
export class IdVerificationEligibilityService {
  constructor(private api: ApiInterfaceService) {}

  /**
   * Checks if the user is eligible for identity verification
   *
   * @returns Observable with EligibilityStatus
   */
  checkEligibility(): Observable<EligibilityStatus> {
    return this.api
      .gqlQuery$<{ eligibleForIdentityVerification: EligibilityStatus }>(IdVerificationEligibilityDocument)
      .pipe(map((data) => data.eligibleForIdentityVerification));
  }
}
